const getStorageKey=(userId)=>(
  userId ? `sohlocal-hide-declined-orders-${userId}` : null
);

export const getHideDeclinedOrders=(userId)=>{
  if (!userId || typeof window==='undefined') return false;

  return window.localStorage.getItem(getStorageKey(userId))==='true';
};

export const setHideDeclinedOrders=(userId,hidden)=>{
  if (!userId || typeof window==='undefined') return;

  window.localStorage.setItem(
    getStorageKey(userId),
    hidden ? 'true' : 'false'
  );

  window.dispatchEvent(new CustomEvent('sohlocal:declined-order-visibility-changed'));
};